
import ReglementsItemComponent from "../../components/Reglements/ReglementsItem";
import { useCurrentReglementQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";


function ReglementsItem(){
    const { data:reglement, error, isLoading } = useCurrentReglementQuery();
    const {translate}=useTrads();
    
    return (

        
        error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        reglement &&
        <>
          
          <ReglementsItemComponent reglement={reglement}  />
        
        </>

    );
}
export default ReglementsItem;